module.exports = __webpack_public_path__ + "img/logo.ff3a4ee0.png";